import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonLabel, IonInput, useIonAlert, IonButtons, IonButton, IonTextarea, IonIcon, IonLoading, IonFab, IonFabButton, IonItemSliding, IonItemOptions, IonItemOption, IonSegment, IonSegmentButton, IonItemDivider } from '@ionic/react';
import { useEffect, useRef, useState } from 'react';
import './ClientCommentEditor.css';
import { useHistory, useParams } from 'react-router';
import dateFormat from 'dateformat';
import { i18n } from "dateformat";
import { cameraOutline, checkmark, chevronBack, crop, documentTextOutline, pencilOutline, printOutline, shareOutline } from 'ionicons/icons';
import { getCurrentUser, getCurrentUserUID } from '../firebase/firebase';
import { addClientComment, getClientComment, removeClientComment } from '../firebase/clientComments';
import { getUser } from '../firebase/users';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { getFileList, removeFile, uploadFile, getFileBlob } from '../firebase/firebaseStorage';
import IonPhotoViewer from '@codesyntax/ionic-react-photo-viewer';
import { Share } from '@capacitor/share';
import { Directory, Filesystem } from "@capacitor/filesystem";
import { Capacitor } from "@capacitor/core";
import write_blob from "capacitor-blob-writer";
import { Editor } from '@tinymce/tinymce-react';
import { Printer } from '@awesome-cordova-plugins/printer';
import { getDocumentTemplate } from '../firebase/documentTemplates';
import { getClient } from '../firebase/clients';
import Permissions from './Permissions';


const ClientCommentEditor: React.FC = () => {
  const editorRef = useRef(null);
  const [tab, setTab] = useState('EditorTab');
  const [busy, setBusy] = useState(false);
  const [pictures, setPictures] = useState<any[]>([]);
  const params: any = useParams();
  const history = useHistory();
  var initData: any = {};

  if (params.id !== undefined && params.id !== 0) {
    initData = getClientComment(params.id);
    if (initData === undefined) {
      initData = {};
    }
  }

  

  function exchangeDate(text:any, key:string, format:string){
    var regex = new RegExp('\\['+key+'([+-]\\d+)\\]', 'mg')
      var findArray = [...text.matchAll(regex)];
      for(var a of findArray){
        var d = new Date();
        d = new Date(d.setDate(d.getDate()+Number(a[1])));
        text = text.replace(a[0], dateFormat(d, format));
      }
      return text
  }

  if (params.templateId !== undefined && params.templateId !== 0) {
    const template = getDocumentTemplate(params.templateId);
    if (template !== undefined) {
      var t = template.text;
      const c = getClient(params.clientId);
      //https://regex101.com
      t = exchangeDate(t, "DATA", "yyyy-mm-dd");
      t = exchangeDate(t, "DZIEN", "dddd");
       

      t = t.replaceAll("[DATA]", dateFormat(new Date(), "yyyy-mm-dd"));
      t = t.replaceAll("[DZIEN]", dateFormat(new Date(), "dddd"));

      t = t.replaceAll("[IMIE]", c.name);
      t = t.replaceAll("[NAZWISKO]", c.surname);
      t = t.replaceAll("[EMAIL]", c.email);
      t = t.replaceAll("[TELEFON]", c.phone);
      t = t.replaceAll("[DATA_URODZENIA]", c.birthday);
      t = t.replaceAll("[ADRES]", c.address);
      t = t.replaceAll("[KOD_POCZTOWY]", c.zipCode);
      t = t.replaceAll("[POCZTA]", c.city);
      t = t.replaceAll("[UWAGI]", c.comments);
      t = t.replaceAll("[PESEL]", c.pesel);
      t = t.replaceAll("[MIEJSCE_URODZENIA]", c.birthdayPlace);
      t = t.replaceAll("[SZKOLA]", c.school);
      t = t.replaceAll("[KLASA]", c.schoolClass);

      t = t.replaceAll("[O_IMIE]", c.gname);
      t = t.replaceAll("[O_NAZWISKO]", c.gsurname);
      t = t.replaceAll("[O_EMAIL]", c.gemail);
      t = t.replaceAll("[O_TELEFON]", c.gphone);
      t = t.replaceAll("[O_ADRES]", c.gaddress);
      t = t.replaceAll("[O_KOD_POCZTOWY]", c.gzipCode);
      t = t.replaceAll("[O_POCZTA]", c.gcity);

      t = t.replaceAll("[F_NAZWA", c.iname);
      t = t.replaceAll("[F_ADRES]", c.iaddress);
      t = t.replaceAll("[F_KOD_POCZTOWY]", c.izipCode);
      t = t.replaceAll("[F_POCZTA]", c.icity);
      t = t.replaceAll("[F_KRAJ]", c.icountry);
      t = t.replaceAll("[F_NIP]", c.ivat);

      initData.comment = t;
      initData.topic = template.topic;
    }
  }

  var isNew = initData.id === undefined;

  function loadFiles(reload = false) {
    setBusy(true)
    getFileList(params.clientId, params.id, reload).then((list) => {
      if (list !== null) {
        setBusy(false);
        setPictures(list);
      }
    });
  }

  useEffect(() => {
    //console.log("ClientCommentEditor", initData, params)
    if (params.id !== undefined && params.id !== 0) {

      loadFiles(false)
      return () => {

      }
    }
  }, []);

  const [presentAlert] = useIonAlert();


  const [topic, setTopic] = useState(initData.topic === undefined ? "" : initData.topic);
  const [comment, setComment] = useState(initData.comment === undefined ? "" : initData.comment);





  async function confirm() {
    if (editorRef.current) {
      var returnData: {
        id: string | null, topic: any, comment: any, updated: any
      } = {
        id: null,
        topic: '',
        comment: '',
        updated: ''
      };

      if (initData.id !== undefined && initData.id !== 0) {
        returnData.id = initData.id;
      }
      returnData.topic = topic;
      //@ts-ignore
      const text = editorRef.current.getContent();
      returnData.comment = text;
      returnData.updated = initData.updated;
      setBusy(true);
      if (await addClientComment(returnData)) {
        history.goBack();
      }
      setBusy(false);
    }
  }

  function remove() {
    presentAlert({
      header: 'Usuwanie!',
      buttons: [
        {
          text: 'Anuluj',
          role: 'cancel'
        },
        {
          text: 'Usuń',
          role: 'confirm',
        },
      ],
      onDidDismiss: async (e: CustomEvent) => {
        if (e.detail.role === 'confirm') {
          setBusy(true);
          if (await removeClientComment(params.id)) {
            history.goBack();
          }
          setBusy(false)
        }
      },
    })
  }

  function removePicture(path: string) {
    presentAlert({
      header: 'Usuwanie!',
      buttons: [
        {
          text: 'Anuluj',
          role: 'cancel'
        },
        {
          text: 'Usuń',
          role: 'confirm',
        },
      ],
      onDidDismiss: async (e: CustomEvent) => {
        if (e.detail.role === 'confirm') {
          setBusy(true);
          if (await removeFile(path)) {
            loadFiles(true);
          } else {
            setBusy(false)
          }
        }
      },
    })
  }

  function cancel() {
    history.goBack();
  }


  function getDescription() {
    var r = "";
    if (initData.created !== undefined) {
      r += dateFormat(initData.created.toDate(), "yyyy-mm-dd HH:MM") + " ";
    }
    if (initData.userId !== undefined) {
      const u = getUser(initData.userId);
      if (u !== undefined) {
        r += "(" + u.initials + ")";
      }
    }

    return r;
  }

  function isEditable() {
    const currenUser = getCurrentUser();
    if ((currenUser.role === "manager" || initData.userId === currenUser.id)) {
      return true;
    }
    return false;
  }

  function getRemoveButton() {

    if (!isNew && isEditable()) {
      if (topic.length === 0) {
        if (pictures.length === 0) {
          return <IonButton slot="end" size="small" color="danger" onClick={() => remove()}>usuń</IonButton>
        }
      }
    }
    return ""
  }

  async function takePhoto() {
    setBusy(true);
    Camera.getPhoto({
      resultType: CameraResultType.Base64,
      source: CameraSource.Prompt,
      quality: 70,
      allowEditing: false,
      promptLabelHeader: 'Wybierz...',
      promptLabelCancel: 'anuluj',
      promptLabelPhoto: 'galeria',
      promptLabelPicture: 'aparat'
    }).then(async (p) => {
      await uploadFile(params.clientId, params.id, p);
      loadFiles(true);
    }).catch((e) => {
      console.error(e)
      setBusy(false);
    })
    setBusy(false)
  }


  function getDateFromPath(path: string) {
    const slices = path.split('/');
    var n = slices[slices.length - 1];
    n = n.substring(0, 14);
    return n.substring(0, 4) + "-" + n.substring(4, 6) + "-" + n.substring(6, 8) + " " + n.substring(8, 10) + ":" + n.substring(10, 12);
  }

  function getUserIdFromPath(path: string) {
    const slices = path.split('_');
    var n = slices[slices.length - 1];
    return n.substring(0, n.indexOf("."));
  }

  async function sharePicture(item: any) {

    //https://firebase.google.com/docs/storage/web/download-files#cors_configuration
    if (Capacitor.isNativePlatform()) {
      const response = await fetch(item.url, { method: "GET", mode: 'cors' });
      const parts = item.path.split("/");
      const name = parts[parts.length - 1];
      var b = await response.blob();

      write_blob({
        path: name,
        directory: Directory.Data,
        blob: b,
        fast_mode: true,
        recursive: true,
        on_fallback(error) {
          console.error(error);
        }
      }).then(function (f) {
        Filesystem.getUri({
          path: name,
          directory: Directory.Data
        }).then(function ({ uri }) {
          Share.share({
            title: 'eGabinet',
            text: '',
            url: uri,
            dialogTitle: '',
          });
        });

      });
    } else {
      window.open(item.url, '_system')
    }

  }

  async function cropPicture(item: any) {
    history.push("/app/imageviewer/" + item.path.replaceAll("/", "-"));
  }

  function print() {
    if (editorRef.current) {
      if (Capacitor.isNativePlatform()) {
        //@ts-ignore
        var text = editorRef.current.getDoc();
        text = new XMLSerializer().serializeToString(text);

        Printer.print(text, {
          name: topic, margin: {
            top: "10",
            left: "55",
            right: "15",
            bottom: "10"
          }
        });
      } else {
        //@ts-ignore
        editorRef.current.contentWindow.print();
      }
    }
  }


  const EditorTab = <div hidden={tab !== "EditorTab"} style={{ height: "100%" }}>

    {/* <IonItem>
    <IonTextarea style={{ height: "100%", width: "100%" }} placeholder="opis" autoGrow={true} value={comment} onIonChange={(e) => { setComment(e.detail.value) }}></IonTextarea>
  </IonItem> */}

    <Editor
      tinymceScriptSrc={'https://egabinet.wiq.pl/app/tinymce/tinymce.min.js'}
      //apiKey='wy7dxy8wo21ot818w8cectp6u6opa4em2m7g21e9oog3had8'

      //@ts-ignore
      onInit={(evt, editor) => editorRef.current = editor}



      initialValue={comment}
      init={{
        height: "100%",
        width: "100%",
        language_url: 'https://egabinet.wiq.pl/app/tinymce/langs/pl.js',
        language: 'pl',
        menubar: true,
        plugins: 'importcss searchreplace directionality ' +
          'code visualblocks visualchars image ' +
          'table charmap pagebreak nonbreaking insertdatetime advlist lists wordcount ' +
          'help charmap quickbars emoticons',

        toolbar: 'undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | ' +
          'outdent indent |  numlist bullist | forecolor backcolor removeformat | ' +
          'pagebreak | charmap emoticons |  | ' +
          'image',
        content_style: `
                      @media (min-width: 620px) {
                        html {
                            background: #eceef4;
                            min-height: 100%;
                            padding: 0 .5rem
                        }

                        body {
                            background-color: #fff;
                            //box-shadow: 0 0 4px rgba(0, 0, 0, .15);
                            //box-sizing: border-box;
                            margin: 1rem auto 0;
                            max-width: 620px;
                            min-height: calc(100vh - 1rem);
                            padding: 0rem 1rem 0rem 3rem
                        }
                    }
                   `,

      }}

    />


  </div>

  // const DataTab = <div style={{ maxWidth: "800px" }} hidden={tab !== "DataTab"}>
  //   <IonItem hidden={isNew}>
  //     <IonLabel>Utworzono</IonLabel>
  //     <IonInput disabled={true} value={getDescription()} />
  //   </IonItem>

  //   <IonItemDivider hidden={pictures.length === 0}>
  //     <IonLabel>
  //       Pliki
  //     </IonLabel>
  //   </IonItemDivider>
  //   {pictures.map((p: any) => (

  //     <IonItemSliding key={p.path}>
  //       <IonItemOptions hidden={false} side="start">
  //         <IonItemOption onClick={(e) => { sharePicture(p) }}><IonIcon icon={shareOutline} hidden={!isEditable()} /></IonItemOption>
  //         <IonItemOption onClick={(e) => { cropPicture(p) }} color="secondary" hidden={!isEditable()}><IonIcon icon={pencilOutline} /></IonItemOption>
  //       </IonItemOptions>
  //       <IonItemOptions hidden={false} side="end">
  //         <IonItemOption color="danger" onClick={(e) => { removePicture(p.path) }}>{"usuń"}</IonItemOption>
  //       </IonItemOptions>
  //       <IonItem >

  //         <IonPhotoViewer
  //           title={getDateFromPath(p.path)}
  //           src={p.url}
  //         >
  //           <IonLabel><IonIcon icon={documentTextOutline} style={{ marginRight: "10px" }} />{getDateFromPath(p.path) + " (" + getUser(getUserIdFromPath(p.path))?.initials + ")"}</IonLabel>
  //         </IonPhotoViewer>
  //       </IonItem>
  //     </IonItemSliding>
  //   ))}

  // </div>

  const PermissionsTab = <div style={{ maxWidth: "800px" }} hidden={tab !== "PermissionsTab"}>
    <Permissions collection={'clients/' + params.clientId + '/comments'} id={params.id} permissions={initData.permissions} updateDate={initData.updated} db={true} goBackAfterSave={false} />
  </div>


  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton color="medium" onClick={() => cancel()}>
              <IonIcon icon={chevronBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>{topic}</IonTitle>
          <IonButtons slot="end">
            <IonButton hidden={tab !== "EditorTab"} onClick={() => print()}><IonIcon icon={printOutline} /></IonButton>
            <IonButton hidden={initData.id !== undefined && (initData.userId !== getCurrentUserUID() && initData.permissions !== undefined && initData.permissions[getCurrentUser().id] !== 'write')} onClick={() => confirm()}><IonIcon icon={checkmark} /></IonButton>
          </IonButtons>

        </IonToolbar>
        {getCurrentUser().role === "manager" || initData.userId === getCurrentUserUID() ?
          <IonSegment value={tab} onIonChange={(v) => { setTab(v.detail.value ?? 'EditorTab') }}>
            <IonSegmentButton value="EditorTab">
              <IonLabel>Dokument</IonLabel>
            </IonSegmentButton>

            <IonSegmentButton value="PermissionsTab">
              <IonLabel>Uprawnienia</IonLabel>
            </IonSegmentButton>


          </IonSegment>
          : ""}
        <IonItem>
          <IonLabel>Temat</IonLabel>
          <IonInput value={topic} placeholder="temat" onIonChange={(e) => { setTopic(e.detail.value) }} />
          {getRemoveButton()}
        </IonItem>
      </IonHeader>
      <IonLoading duration={0} isOpen={busy} />

      <IonContent style={{ height: "100%" }}>

        {EditorTab}
        {PermissionsTab}


      </IonContent>



    </IonPage>
  );
};

export default ClientCommentEditor;
